import { searchRequest } from '../../http'

import config from '../../../config'

export default async function getPricingAndCrn(
  pricingFunc: () => Promise<CommonPricingResponse>,
  businessUnitName: 'Biosecurity' | 'NSW Food Authority',
) {
  const pricingResponse = await pricingFunc()

  const crnSet = new Set<string>()
  pricingResponse.facilities__hidden.forEach((facility) => {
    if (!('paymentResponse' in facility)) return
    if (facility.price > 0) {
      if (facility.paymentResponse?.ApplyFee_CRN) {
        crnSet.add(facility.paymentResponse.ApplyFee_CRN)
      }
      if (facility.paymentResponse?.Permission_CRN) {
        crnSet.add(facility.paymentResponse.Permission_CRN)
      }
    }
  })
  if (pricingResponse.products__hidden) {
    pricingResponse.products__hidden.forEach((product) => {
      if (product.pricingResponse.CRN && product.price > 0) {
        crnSet.add(product.pricingResponse.CRN)
      }
    })
  }
  let customerReferenceNumber = ''
  if (crnSet.size === 1) {
    customerReferenceNumber = Array.from(crnSet)[0]
  }

  if (!customerReferenceNumber) {
    const crnResponse = await searchRequest<{
      Default_Revenue_CRN: string
    }>({
      url: `${config.HOSTED_API_URL}/payments/default-crn`,
      searchParameters: {
        businessUnitName,
      },
    })
    customerReferenceNumber = crnResponse.Default_Revenue_CRN
  }

  return { pricingResponse, customerReferenceNumber }
}
